export default "__VITE_ASSET__Bt$TP4nz__"